export const getEmptyAutocompleteQuery = /* GraphQL */ `
    query getEmptyAutocomplete {
        getEmptyAutocomplete {
            categories {
                id
                name
                url
            }
            products {
                sku
                name
                url
                small_image
                price {
                    regular_price {
                        value
                        currency
                    }
                    final_price {
                        value
                        currency
                    }
                    discount {
                        amount_off
                        percent_off
                    }
                }
            }
        }
    }
`
